import DesignedFor from "./components/DesignedFor";
import Header from "./components/Header";
import Hero from "./components/Hero";
import InvoiceSteps from "./components/InvoiceSteps";

function App() {
  return (
    <>
      <div>
        <Header />
        <Hero />
        <InvoiceSteps />
        <DesignedFor />
      </div>
    </>
  );
}

export default App;
